import ReactDOM from 'react-dom';
import App from './App';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

ReactDOM.render(
  <GoogleReCaptchaProvider reCaptchaKey='6LfwW2YjAAAAAMrxTpFz-taZm6UPatWccWyDevGY'>
    <App />
  </GoogleReCaptchaProvider>,
  document.getElementById('root')
);
